// this returns an encoded version of the current path
// but makes sure it is not longer than 100 characters
export default function getRefUrl() {
    let refUrl = encodeURIComponent(window.location.href);
    if (refUrl.length > 100) {
        refUrl = refUrl.substring(100);
    }
    return refUrl;
}
